import r from "./_createBaseFor.js";
var a = r, e = a(), s = e;
export {
  s as default
};
//# sourceMappingURL=_baseFor.js.map
